<template>
  <div class="column is-10">
    <div class="box">
      <table class="table is-bordered is-striped is-fullwidth">
        <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <expense-categories-row
          v-for="(row, index) in expenseCategories"
          v-bind:key="row.id"
          :initial-row="row"
          :index="index"
        />
        <tr>
          <td>Add new category</td>
          <td>
            <input class="input" type="text" v-model="name" placeholder="Category name">
          </td>
          <td>
            <button
              class="button is-primary"
              @click="saveCategory"
            >
              Save
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import EXPENSE_CATEGORIES from '@/graphql/expense-categories/expenseCategories.gql';
import CREATE_EXPENSE_CATEGORY from '@/graphql/expense-categories/createExpenseCategory.gql';
import ExpenseCategoriesRow from './ExpenseCategoriesRow.vue';

export default {
  name: 'ExpenseCategories',
  components: { ExpenseCategoriesRow },
  data() {
    return {
      expenseCategories: null,
      name: '',
    };
  },
  apollo: {
    expenseCategories: EXPENSE_CATEGORIES,
  },
  methods: {
    saveCategory() {
      this.$apollo.mutate({
        mutation: CREATE_EXPENSE_CATEGORY,
        variables: {
          name: this.name,
        },
      })
        .then(() => {
          this.name = '';
          this.$toasted.success('Category saved!');
          this.$apollo.queries.expenseCategories.refetch();
        })
        .catch((error) => {
          this.$toasted.error(error);
        });
    },
  },
};
</script>

<style scoped>

</style>
